export default __webpack_public_path__ + "static/media/balkouras-nicos-8tadBT_8Gag-unsplash-medium.9bb0dd3b.jpg";